(function () {
  angular.module("akitabox.desktop.request.organizationList", [
    "akitabox.core.constants",
    "akitabox.core.services.building",
    "akitabox.core.services.filter",
    "akitabox.core.services.request",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.export",
    "akitabox.desktop.components.filterBarManager",
  ]);
})();
